import {COUNTRIES, ENVIRONMENTS, COUNTRY} from 'core/constants/env';

const DEFAULT_DEV_LINK = 'https://codifier-processor-refdev.pmark.tracecore.solutions';

export const CODIFIERS_LINK_MAP: Record<COUNTRIES, Partial<Record<ENVIRONMENTS, string>>> = {
    CAR: {
        development: DEFAULT_DEV_LINK,
        demo: 'https://codifier-processor-demo.car.tracecore.solutions',
        stage: 'https://codifier-processor-stg.car.tracecore.solutions',
        production: 'https://codifier-processor.rcatfe.com',
    },
    NG: {
        development: 'https://codifier-processor-ngdev.pmark.tracecore.solutions',
        demo: 'https://codifier-processor-ng01.pmark.tracecore.solutions',
    },
    TJ: {},
};

export const CODIFIERS_LINK =
    CODIFIERS_LINK_MAP[COUNTRY]?.[process.env.REACT_APP_ENV as ENVIRONMENTS] ?? DEFAULT_DEV_LINK;
